import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ILabRegistration } from '../../models/lab-user-menu/lab-registration';
import { LabUserMenuService } from '../../services/lab-user-menu/lab-user-menu.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { SharedService } from '@shared/services/shared.service';
import { MenuService } from 'app/services/core/menu.service';

@Component({
  selector: 'app-lab-user-menu',
  templateUrl: './lab-user-menu.component.html',
  styleUrls: ['./lab-user-menu.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class LabUserMenuComponent implements OnInit, AfterViewInit {
  labs: ILabRegistration[] = [];

  displayedColumns: string[] = ['orelapId', 'laboratoryName', 'primaryAa', 'accreditationType'];
  dataSource = new MatTableDataSource<ILabRegistration>(this.labs);

  expandedElement: ILabRegistration | null;
  selectedLab: string = '';

  activeUser: Boolean = false;
  loaded: Boolean = false;

  @ViewChild('ApplicationPaginator') paginator: MatPaginator;
  @ViewChild('ApplicationSort') sort: MatSort;

  constructor(
    private service: LabUserMenuService,
    private sharedService: SharedService,
    private menu: MenuService
  ) {
    // There are 5 cases to consider on load:
    // 1. Active user with labs, show menu and lab listing
    // 2. Active user with no labs, send to registration 
    // 3. No active user, show message to contact admin for approval
    // 4. Error, show message to contact admin for approval
    // 5. New user with no labs, send to registration
    this.service.getUserLabs().subscribe(
      labList => {
        this.labs = labList;
        this.service.activeUser().subscribe(
          response => {

            if (response && this.labs.length > 0) {
              // Active user with labs, show menu and lab listing
              this.activeUser = response;
              this.loaded = true;
              this.menu.modifyLabel('Login', 'Lab Listing');
              this.dataSource.data = this.labs;
              this.dataSource.filter = this.service.labFilter;
              if (this.service.expandedElement != null) {
                this.expandedElement = this.service.expandedElement;
                this.selectedLab = this.service.expandedElement.orelapId;
              }
            } else if (response && this.labs.length == 0) {
              // Active user with no labs, Send to warning
              this.loaded = true;
              this.activeUser = false;
            } else if (!response && this.labs.length > 0) {
              // No active user, show message to contact admin for approval
              this.loaded = true;
              this.activeUser = false;
            } else if (!response && this.labs.length == 0) {
              // New user with no labs, send to registration
              this.sharedService.doRedirect('register-lab');
            }
          },
          error => console.log('error', error),
          () => { }
        );

      },
      error => console.log('error', error)
    );
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    // Assign paginator and sort after view is initialized
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  rowclick(row: ILabRegistration) {
    this.expandedElement = this.expandedElement === row ? null : row;
    this.service.expandedElement = this.expandedElement;
    this.selectedLab = this.expandedElement == null ? null : row.orelapId;
  }

  filterTable(value: string) {
    this.dataSource.filter = value.trim().toLowerCase();
    this.service.labFilter = this.dataSource.filter;
  }

  downloadHelpFile(): void {
    this.sharedService.downloadHelpFile("APP").subscribe(
      response => this.downloadFile("Help", response),
      error => console.log('error', error)
    );
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }
}
